import { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'

function NavbarAdmin() {
    const navbarBottom = useRef()
    const navbarDesktop = useRef()
    const lastScrollY = useRef(0)

    function controlNavbar() {
        if (window.scrollY > lastScrollY.current) {
            navbarBottom.current.style.bottom = '-5rem'
            navbarDesktop.current.style.bottom = '-5rem'
        }
        else {
            navbarBottom.current.style.bottom = '0'
            navbarDesktop.current.style.bottom = '0px'
        }
        lastScrollY.current = window.scrollY
    }

    useEffect(() => {
        window.addEventListener('scroll', controlNavbar)
        return () => { window.removeEventListener('scroll', controlNavbar) }
    }, [lastScrollY])

    return (<>
        <div className='navbar_desktop' ref={navbarDesktop}>
            {/* ----------- DESKTOP ------------- */}
            <div>
                <Link to={{ pathname: '/myEventiTable' }} style={{ textDecoration: 'none', color: 'gainsboro' }}>
                    My Eventi
                </Link>
            </div>
            <div>
                <Link to={{ pathname: '/checkEvent' }} style={{ textDecoration: 'none', color: 'gainsboro' }}>
                    Check eventi
                </Link>
            </div>
            <div>
                <Link to={{ pathname: '/jpegToBase64' }} style={{ textDecoration: 'none', color: 'gainsboro' }}>
                    RidImg
                </Link>
            </div>
            <div>
                <Link to={{ pathname: '/videoCompress' }} style={{ textDecoration: 'none', color: 'gainsboro' }}>
                    RidMp4
                </Link>
            </div>
            <div>
                <Link to={{ pathname: '/myEventiTable' }} style={{ textDecoration: 'none', color: 'gainsboro' }}>
                    ⇅⇅
                </Link>
            </div>
        </div>
        <div style={{ backgroundColor: 'floralwhite' }}></div>

        {/*--------------- MOBILE ------------*/}
        <div className='navbar_bottom' ref={navbarBottom}>
            <div>
                <Link to={{ pathname: '/myEventiTable' }} style={{ textDecoration: 'none', color: 'gainsboro' }}>
                    My
                </Link>
            </div>
            <div>
                <Link to={{ pathname: '/checkEvent' }} style={{ textDecoration: 'none', color: 'gainsboro' }}>
                    Check eventi
                </Link>
            </div>
            <div>
                <Link to={{ pathname: '/jpegToBase64' }} style={{ textDecoration: 'none', color: 'gainsboro' }}>
                    RidImg
                </Link>
            </div>
            <div>
                <Link to={{ pathname: '/videoCompress' }} style={{ textDecoration: 'none', color: 'gainsboro' }}>
                    RidMp4
                </Link>
            </div>
        </div>
    </>)
}
export default NavbarAdmin